module.exports = __webpack_public_path__ + "img/tv.6b38cb.png";